import { FC, PropsWithChildren } from 'react';
import { Grid, useMediaQuery, useTheme } from '@mui/material';

export const AccountStatisticsLayout: FC<PropsWithChildren> = ({
  children,
}) => {
  const theme = useTheme();
  const hasSpace = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <Grid
      container
      direction={hasSpace ? 'row' : 'column'}
      spacing={hasSpace ? 8 : 6}
      my={{
        xs: 3,
        sm: 4,
        md: 6,
      }}
      sx={{
        alignItems: 'stretch',
        justifyContent: hasSpace ? 'space-between' : 'center',
        width: '100%',
      }}
    >
      {children}
    </Grid>
  );
};
